import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';

interface IFileDropZoneProps {
    message: string,
    drag_message: string,
    OnDropFiles: (files: any) => void
    file_types?: string[],
    maxSize?: number
}

const FileDropZone = ({ message, drag_message, maxSize=1048576*100, file_types=[], OnDropFiles }: IFileDropZoneProps) => {
    const onDropAccepted = useCallback(acceptedFiles => {
        if(acceptedFiles.length) {
          OnDropFiles(acceptedFiles);
        }
      }, []);

      const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDropAccepted, 
        accept: file_types.length ? file_types.concat(',') : '',
        maxSize: maxSize,
      });

      return (
        <div {...getRootProps()} 
          className="align-items-center border-secondary d-flex flex-grow-1 rounded text-center text-lg w-100" 
          style={{borderStyle: 'dashed', borderWidth: '3px'}}>
          <input {...getInputProps()} className="w-100"/>
          {
            isDragActive ?
              <div className="flex-grow-1 font-weight-bold mb-0">{ drag_message }</div> :
              <div className="flex-grow-1 font-weight-bold mb-0">{ message }</div>
          }
        </div>
      )
}

export default FileDropZone;


